import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useAuth } from '../contexts/AuthContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/LoginTeacherPage.css';
import { GoogleLogin } from 'react-google-login';

const LoginTeacherPage = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { loginTeacher, user } = useAuth();
    const navigate = useNavigate();

    // Redirect if already logged in
    React.useEffect(() => {
        if (user) {
            navigate('/');
        }
    }, [user, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setMessage('');

        const result = await loginTeacher(username, password);
        
        if (result.success) {
            setMessage('Inicio de sesión exitoso. Redirigiendo...');
            setTimeout(() => {
                navigate('/');
            }, 1500);
        } else {
            setMessage(result.message || 'Error durante el inicio de sesión');
        }
        
        setIsLoading(false);
    };

    const handleLoginSuccess = async (response) => {
        try {
            const res = await fetch('/api/teachers/google-login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ token: response.tokenId }),
            });
            
            const data = await res.json();
            
            if (data.success) {
                setMessage('Inicio de sesión exitoso. Redirigiendo...');
                setTimeout(() => {
                    navigate('/');
                }, 1500);
            } else {
                setMessage(data.message || 'Error durante el inicio de sesión');
            }
        } catch (error) {
            setMessage('Ha ocurrido un error durante el inicio de sesión.');
        }
    };

    const handleLoginFailure = (response) => {
        setMessage('Ha ocurrido un error durante el inicio de sesión con Google.');
    };

    if (user) {
        return <div>Redirigiendo...</div>;
    }

    return (
        <div>
            <Helmet>
                <title>Iniciar Sesión</title>
                <meta property="og:title" content="Iniciar Sesión" />
                <meta property="og:description" content="Inicia sesión en el portal de maestros." />
                <meta property="og:image" content="https://primarturogro.edu.mx/uploads/LogoArturo.png" />
                <meta property="og:url" content="https://primarturogro.edu.mx/login" />
                <meta property="og:type" content="website" />
            </Helmet>
            <div className="d-flex justify-content-center align-items-center vh-100" style={{ backgroundColor: '#f0f0f0' }}>
                <div className="p-4 bg-white rounded shadow">
                    <h1 className="text-center mb-4" style={{ fontSize: '1.5rem' }}>Inicio de Sesión</h1>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label htmlFor="username" className="form-label" style={{ fontSize: '0.875rem' }}>Nombre de usuario:</label>
                            <input 
                                type="text" 
                                id="username" 
                                className="form-control" 
                                value={username} 
                                onChange={(e) => setUsername(e.target.value)} 
                                required 
                                disabled={isLoading}
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="password" className="form-label" style={{ fontSize: '0.875rem' }}>Contraseña:</label>
                            <input 
                                type="password" 
                                id="password" 
                                className="form-control" 
                                value={password} 
                                onChange={(e) => setPassword(e.target.value)} 
                                required 
                                disabled={isLoading}
                            />
                        </div>
                        <button 
                            type="submit" 
                            className="btn btn-primary w-100"
                            disabled={isLoading}
                        >
                            {isLoading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
                        </button>
                    </form>
                    <div className="mt-3">
                        <GoogleLogin
                            clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                            buttonText="Iniciar sesión con Google"
                            onSuccess={handleLoginSuccess}
                            onFailure={handleLoginFailure}
                            cookiePolicy={'single_host_origin'}
                            className="w-100"
                        />
                    </div>
                    {message && (
                        <p className={`mt-3 text-center ${message.includes('exitoso') ? 'text-success' : 'text-danger'}`} style={{ fontSize: '0.875rem' }}>
                            {message}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default LoginTeacherPage;